import React from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText } from '@keen.io/typography';
import { colors } from '@keen.io/colors';
import { IncludesToday } from './RelativeTimeLabel.styles';
import { getInterval } from '../../../../utils';

var RelativeTimeLabel = function RelativeTimeLabel(_ref) {
  var relativity = _ref.relativity,
      value = _ref.value,
      units = _ref.units;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var interval = getInterval(units);
  return React.createElement(BodyText, {
    variant: "body2",
    color: colors.blue[500],
    enableTextEllipsis: true
  }, React.createElement("span", null, t('query_creator_relative_time_label.label'), " ", value, " ", units), relativity === 'this' && React.createElement(IncludesToday, null, interval === 'day' ? t('query_creator_relative_time_label.today_includes') : "(".concat(t('query_creator_relative_time_label.relativity_title'), " ").concat(interval, ")")));
};

export default RelativeTimeLabel;